import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableMocksIfNeeded } from '@vendasta/core';
import { AppModule } from './app/app.module';
import { getEnvironment } from './environments';
import { captureInitialQueryString } from './app/initial-query';

captureInitialQueryString();

if (getEnvironment().production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', async () => {
  await enableMocksIfNeeded();

  platformBrowserDynamic()
    .bootstrapModule(AppModule, {
      applicationProviders: [provideZoneChangeDetection()],
    })
    .catch((err) => console.error(err));
});
